import { Box } from "@mui/material";
import React, { useState } from "react";
import { USER_TYPE } from "../../common/constants";
import MDropdown from "../../components/MDropdown";
import SessionDetails from "../../helpers/sessionDetails";
import "./approval.scss";
import FamilyComponent from "./components/family/family.component";
import HelplineComponent from "./components/helpline/helpline.component";
import NewsComponent from "./components/news/news.component";
import StoryComponent from "./components/stories/story.component";

export default function Approvals(props) {
  const [approvalTypes, setApprovalTypes] = useState([
    "Family",
    "News",
    "Stories",
    "Help approval",
  ]);
  const [approvalType, setApprovalType] = useState("Family");

  React.useEffect(() => {
    const user = SessionDetails.getCurrentUser();
    if (
      user.userType.includes(USER_TYPE.MASTER_ADMIN) ||
      user.userType.includes(USER_TYPE.JAMAT_ADMIN)
    ) {
      setApprovalTypes(["Family", "News", "Stories", "Help approval"]);
    } else {
      let approvalsArray = ["Family"];
      if (user.userType.includes(USER_TYPE.NEWS_ADMIN)) {
        approvalsArray.push("News");
      }

      if (user.userType.includes(USER_TYPE.STORIES_ADMIN)) {
        approvalsArray.push("Stories");
      }

      approvalsArray.push("Help approval");
      setApprovalTypes(approvalsArray);
    }
  }, []);

  const getApprovalView = () => {
    switch (approvalType) {
      case "Family":
        return <FamilyComponent approvalType={approvalType} />;
      case "News":
        return (
          <NewsComponent
            approvalType={approvalType}
            onPageChange={(page, params) => props.onPageChange(page, params)}
          />
        );
      case "Stories":
        return (
          <StoryComponent
            approvalType={approvalType}
            onPageChange={(page, params) => props.onPageChange(page, params)}
          />
        );

      case "Help approval":
        return (
          <HelplineComponent
            approvalType={approvalType}
            onPageChange={(page, params) => props.onPageChange(page, params)}
          />
        );
    }
  };

  return (
    <Box className={"approvals-component d-flex flex-column p-md-3"}>
      {approvalTypes.length > 1 ? (
        <Box className='approvalDropdown'>
          <MDropdown
            className={"input"}
            label=""
            name={"approval"}
            value={approvalType}
            onChange={(e) => setApprovalType(e.target.value)}
            options={approvalTypes}
          />
        </Box>
      ) : null}

      {getApprovalView()}
    </Box>
  );
}
